import { render, staticRenderFns } from "./createCollege.vue?vue&type=template&id=ab28d6d4&scoped=true"
import script from "./createCollege.vue?vue&type=script&lang=js"
export * from "./createCollege.vue?vue&type=script&lang=js"
import style0 from "./createCollege.vue?vue&type=style&index=0&id=ab28d6d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab28d6d4",
  null
  
)

export default component.exports